export const durataMediaChiamateTexts = {
    tooltipText: "Durata media delle chiamate ricevute ed in uscita, espressa in formato hh:mm:ss.",
    cardTitle: "Durata Media Chiamate"
}

export const durataMediaEffettuateTexts = {
    tooltipText: "Durata media delle chiamate in uscita, espressa in formato hh:mm:ss.",
    cardTitle: "Durata Media Effettuate"
}

export const durataMediaRicevuteTexts = {
    tooltipText: "Durata media delle chiamate ricevute, espressa in formato hh:mm:ss.",
    cardTitle: "Durata Media Ricevute"
}

export const tentativiChiamataTexts = {
    tooltipText: "Valore percentuale dei tentativi di chiamata, intesi come rapporto tra chiamate effettuate senza risposta e chiamate effettuate con risposta.",
    cardTitle: "Tentativi di chiamata"
}

export const chartCountChiamateTexts = {
    tooltipText: "Numero delle chiamate totali dei dispositivi selezionati, divise per tipologia.",
    cardTitle: "Numero totale delle chiamate"
}

export const chartDeviceChiamateTexts = {
    tooltipText: "Somma della durata delle chiamate effettuate per singolo dispositivo selezionato ed espressa in secondi.",
    cardTitle: "Durata totale chiamate effettuate per dispositivo"
}

export const chartDurataChiamateTexts = {
    tooltipText: "Somma della durata delle chiamate totali dei dispositivi selezionati, divise per tipologia ed espressa in secondi.",
    cardTitle: "Durata totale delle chiamate"
}

export const riepilogoTentativiMediaChiamateTexts = {
    tooltipText: "Media del numero di chiamate effettuate prima di ricevere una risposta dal destinatario.",
    cardTitle: "Tentativi chiamata media"
}